<span class="root {{ color ? '-theme-' + color : null }}">
  <ng-content></ng-content>
</span>
